module.exports = __webpack_public_path__ + "assets/img/Inspection.cfda4abe.svg";